import { PostOrPage } from "@tryghost/content-api";
import { formatDistance } from "date-fns";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";
import { VerticalSpacing } from "../VerticalSpacing";
import { BlogPostAuthorImageMetadata, BlogPostAuthorImage, BlogPostAuthorImageName } from "./BlogPostAuthor.styles";

interface BlogPostAuthorProps {
    post: PostOrPage;
    isPostPreview?: boolean;
    postPage?: boolean;
}

export const BlogPostAuthor = ({ post, isPostPreview, postPage = false }: BlogPostAuthorProps) => (
    <BlogPostAuthorImageMetadata>
        <div>
            <UnstyledLink
                href={`${APPLICATION_ROUTES.BLOG_AUTHOR}/${post.primary_author?.slug}`}
                aria-label={`Read more about ${post.primary_author?.name || ""}`}
            >
                <BlogPostAuthorImage src={post.primary_author?.profile_image || ""} alt={`Image of ${post.primary_author?.name}`} />
            </UnstyledLink>
        </div>
        <div>
            <VerticalSpacing bottom={2}>
                <UnstyledLink href={`${APPLICATION_ROUTES.BLOG_AUTHOR}/${post.primary_author?.slug}`}>
                    <BlogPostAuthorImageName isPostPreview={isPostPreview} as="p">
                        {post.primary_author?.name}
                    </BlogPostAuthorImageName>
                </UnstyledLink>
            </VerticalSpacing>
            <V3BodyGrey48 suppressHydrationWarning>
                {postPage ? post.primary_author?.location : formatDistance(new Date(post.published_at || ""), new Date(), { addSuffix: true })}
            </V3BodyGrey48>
        </div>
    </BlogPostAuthorImageMetadata>
);
